import React, { FC, Fragment, useState, memo } from 'react'

import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'

import IconInfo from '@ucheba/ui/icons/icon__info.svg'
import Logo from '../components/Logo'

import { IRankingsItemProps } from '../types'
import { getText } from '../bll'

import SC from '../base/InstitutionRatesItem.styles'

const { Divide, TooltipStyled, GridColStyled, GridStyled } = SC

const InstitutionRankingsItem: FC<IRankingsItemProps> = ({ data }) => {
  const [countItems, setCountItems] = useState(1)
  const { rankingDataList, rankingYear } = data
  const {
    year,
    ranking: { id: yearId },
  } = rankingYear

  const items = [...rankingDataList].sort((prev) => {
    if (prev.ranking.id === yearId) {
      return -1
    }
    return 0
  })

  const handleShowAllClick = (): void => setCountItems(Infinity)

  return (
    <>
      <Divide />

      <Spacing spacing='xlarge' />

      {items.slice(0, countItems).map((item, index) => {
        const isYear = index === 0
        const { isOutOfWorldRank, isOutOfRank } = item

        return (
          <Fragment key={item.ranking.id}>
            {isYear && (
              <GridStyled spacing='xsmall' nowrap>
                <GridColStyled uxs={16} lg={17}>
                  {(rankingYear.ranking.logo || item.ranking.logo) && (
                    <Logo
                      logo={rankingYear.ranking.logo || item.ranking.logo}
                      url={item.ranking.url}
                    />
                  )}

                  {rankingYear?.ranking?.description && (
                    <TooltipStyled
                      width='400px'
                      position='right-center'
                      content={
                        <Text color='black'>{rankingYear.ranking.description}</Text>
                      }
                    >
                      <IconInfo
                        width='20px'
                        height='20px'
                        style={{ verticalAlign: 'middle' }}
                      />
                    </TooltipStyled>
                  )}
                </GridColStyled>

                <GridColStyled uxs={5} lg={4}>
                  <Text textAlign='right' color='gray60' fontSize='small1' nowrap>
                    Место в мире
                  </Text>
                </GridColStyled>
                <GridColStyled uxs={3} lg={3}>
                  <Text textAlign='right' color='gray60' fontSize='small1' nowrap>
                    в России
                  </Text>
                </GridColStyled>
              </GridStyled>
            )}

            <Spacing spacing='xsmall' />

            <GridStyled nowrap>
              <GridColStyled uxs={16} lg={17}>
                <Text
                  as='span'
                  fontSize={isYear ? 'h3' : 'medium'}
                  fontWeight={isYear ? 'bold' : 'regular'}
                >
                  {item.ranking.name}
                </Text>
                {isYear && (
                  <Text
                    as='span'
                    fontSize='h3'
                    fontWeight='bold'
                    color='gray50'
                    style={{ marginLeft: 8 }}
                  >
                    {year}
                  </Text>
                )}
              </GridColStyled>

              <GridColStyled uxs={5} lg={4}>
                <Text
                  nowrap
                  textAlign='right'
                  fontSize={isYear ? 'h3' : 'medium'}
                  fontWeight={isYear ? 'bold' : 'regular'}
                >
                  {getText(item.worldRankFrom, item.worldRankTo, isOutOfWorldRank)}
                </Text>
              </GridColStyled>
              <GridColStyled uxs={3} lg={3}>
                <Text
                  nowrap
                  textAlign='right'
                  fontSize={isYear ? 'h3' : 'medium'}
                  fontWeight={isYear ? 'bold' : 'regular'}
                >
                  {getText(item.rankFrom, item.rankTo, isOutOfRank)}
                </Text>
              </GridColStyled>
            </GridStyled>
          </Fragment>
        )
      })}

      {items.length > countItems && (
        <Button view='link' size='small' onClick={handleShowAllClick}>
          Показать рейтинги по направлениям
        </Button>
      )}

      <Spacing spacing='large' />
    </>
  )
}

export default memo(InstitutionRankingsItem)
